import React from "react";
import PropTypes from "prop-types";

import ClipboardCopy from '@components/common/clipboard_copy/main';
import AttachmentSidebar from '../shared/attachment_sidebar/main';
import VisibleAttachment from '../shared/visible_attachment/main';
import './styles/main';

class MetadataTab extends React.Component {
  state = {
    visibleAttachment: {},
    attachments: [],
    loading: true
  };

  /* NOTE :: When you have a parent modal component that grabs the asset info
  you won't need to grab the attachments on each tab, you can grab them when
  you load the modal and then just pass them down. Attachments will also no
  longer need to be stored in state when this happens */
  componentDidMount() {
    this.attachmentsRequest = $.ajax({
      context: this,
      type: "GET",
      url: `/api/v4/assets/${
        this.props.assetId
      }/attachments?fields=best_metadata,other_metadata,thumbnail_url,extension,extracted_colors,extract_document_text`,
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", `Bearer ${BF_Token}`);
      },
      success: (response) => {
        const sortedAttachments = response.data.sort((a, b) => (
          a.attributes.position > b.attributes.position ? 1 : -1
        ));
        this.setState({
          attachments: sortedAttachments,
          loading: false,
          visibleAttachment: response.data[0],
        });
      },
      error: () => {
        // TODO Create error state
        this.setState({ loading: false });
      }
    });
  }

  componentWillUnmount() {
    this.attachmentsRequest.abort();
  }

  updateActiveImage = ({ id: attachmentId }) => {
    if (this.state.visibleAttachment.id !== attachmentId) {
      this.setState((prevState) => {
        const visibleAttachment = prevState.attachments.find((attachment) => (
          attachment.id === attachmentId
        ));
        return { visibleAttachment };
      });
    }
  }

  searchMetadata = (objectKey, objectValue) => {
    const searchTerm = `metadata.${objectKey}:"${objectValue}"`;
    BF.dialog.dismiss();
    BF.fx.fillInAndFilterQuery(searchTerm);
  }

  renderColorBreakdown() {
    const colorArray = this.state.visibleAttachment.attributes.extracted_colors;

    return colorArray.map((color, i) => {
      const colorStyle = {};
      colorStyle.width = `${Math.floor(parseFloat(color.percentage))}%`;
      colorStyle.background = color.color.hex_color;
      return (
        <div
          key={`color-bar-element-${i}-${color.color.hex_color}`}
          className="color-breakdown-element"
        >
          <div
            className="color-block"
            style={{ background: color.color.hex_color }}
          />
          <ClipboardCopy
            textToCopy={color.color.hex_color}
            check
            showFeedbackAsTooltip={false}
          >
            {color.color.hex_color}
          </ClipboardCopy>
        </div>
      );
    });
  }

  renderMetadata = (passed_metadata, type) => {
    const { orgSearchPage } = this.props;

    // clickable via button
    const metadataShowPage = (metadataKey, metadataValue) => (
      <span>
        <button
          className="link"
          onClick={() => this.searchMetadata(metadataKey, metadataValue)}
          type="button"
        >
          &nbsp;{metadataValue}&nbsp;
        </button>
      </span>
    );

    // clickable via anchor tag
    const metadataOrgSearch = (metadataKey, metadataValue) => {
      const orgSlug = window.location.pathname.split("organizations/")[1].split("/search")[0];

      return (
        <span>
          <a href={`/organizations/${orgSlug}/search?q=metadata.${metadataKey}:"${encodeURI(metadataValue)}"`}>
            {metadataValue}
          </a>
        </span>
      );
    };

    return Object.keys(passed_metadata).map((metadataKey) => {
      const objectValue = passed_metadata[metadataKey];
      return (
        <div className="meta-row" key={`best-meta-${metadataKey}`}>
          <span> {metadataKey}: </span>
          {type !== 'best' || BFG.manifestDigest ? <span> {objectValue} </span> : null}
          {type === 'best' && !BFG.manifestDigest && !orgSearchPage ? metadataShowPage(metadataKey, objectValue) : null}
          {type === 'best' && orgSearchPage ? metadataOrgSearch(metadataKey, objectValue) : null}
        </div>
      );
    });
  }

  render() {
    const { attachments, loading, visibleAttachment } = this.state;
    const activeCard = (visibleAttachment && Object.keys(visibleAttachment).length)
      ? { id: visibleAttachment.id, type: 'attachment' }
      : null;

    return (
      <div className="flex-wrapper metadata-tab-container">
        <AttachmentSidebar
          attachments={attachments.length ? attachments : null}
          updateActiveCard={this.updateActiveImage}
          activeCard={activeCard}
        />
        {loading ? (
          <div className="flex-two-thirds no-similar-details loader-container">
            <video
              className="brandfolder-loader"
              width="90"
              height="90"
              poster="https://cdn.brandfolder.io/4OQZ5PW1/as/pxmju5-qfr48-21nt37/generic-loader.gif"
            />
          </div>
        ) : (
          <div className="flex-two-thirds metadata-details">
            {visibleAttachment && visibleAttachment.attributes
              ? (
                <React.Fragment>
                  <VisibleAttachment
                    extension={visibleAttachment.attributes.extension}
                    filename={visibleAttachment.attributes.filename}
                    height={visibleAttachment.attributes.height}
                    size={visibleAttachment.attributes.size}
                    thumbnail={visibleAttachment.attributes.thumbnail_url}
                    width={visibleAttachment.attributes.width}
                  />
                  {/* We don"t have this yet
                  <div className="attachment-tags">
                    <label>Tags</label>
                  </div>
                  <hr />
                    */}
                  <div className="attachment-colors">
                    <p>{t('Extracted color palette')}</p>
                    <div className="color-breakdown">
                      {visibleAttachment.attributes.extracted_colors
                        ? this.renderColorBreakdown()
                        : t(" No colors extracted")}
                    </div>
                  </div>
                  <hr />
                  {BFG.context.hasFeature('document_search') && visibleAttachment.attributes.extract_document_text && visibleAttachment.attributes.extract_document_text.length > 0
                    ? (
                      <React.Fragment>
                        <div className="attachment-extracted-text">
                          <p>{t('Text from image')}</p>
                          <div className="attachment-metadata-box">
                            {visibleAttachment.attributes.extract_document_text}
                          </div>
                        </div>
                        <hr />
                      </React.Fragment>
                    )
                    : ''}
                  <div className="attachment-metadata">
                    <p>{t('Metadata')}</p>
                    <div className="attachment-metadata-box">
                      {visibleAttachment.attributes.best_metadata
                        ? this.renderMetadata(visibleAttachment.attributes.best_metadata, "best")
                        : t('No metadata')
                      }
                      {visibleAttachment.attributes.other_metadata
                        ? this.renderMetadata(visibleAttachment.attributes.other_metadata, "other")
                        : t('No metadata')
                      }
                    </div>
                  </div>
                </React.Fragment>
              ) : ''
            }
          </div>
        )}
      </div>
    );
  }
}

MetadataTab.propTypes = {
  assetId: PropTypes.string.isRequired,
  orgSearchPage: PropTypes.bool,
};

MetadataTab.defaultProps = {
  orgSearchPage: false,
};

export default MetadataTab;
